import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const endCallApi = createAsyncThunk(
  "END_CALL_SLICE",
  async (userData) => {
    let raw = JSON.stringify(userData);
    let config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.patch(
        `${API_BASE_URL}/appointment/${userData.id}`,

        raw,
        config
      );
      let status = "success";
      let data_res = {
        status: status,
        message: response,
      };
      return data_res;
    } catch (error) {
      let status = "error";
      let data_error = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return data_error;
    }
  }
);

const EndCallSlice = createSlice({
  name: "END_CALL_API",
  initialState: {
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(endCallApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(endCallApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(endCallApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default EndCallSlice.reducer;
